import { Component, OnInit, Input, Output,EventEmitter} from '@angular/core';
import{matriculaService, LoopBackAuth, listadosService, validacionService} from '../services/api-rest.service';
import{MessageService} from '../services/message.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'select-curso-especialidad-paralelo',
  template: `
  <div class="row" style="clear:left">
    <div class="col-sm-4">
      <div class="input-group input-group-sm mb-0">
          <select
          name="alumnoTipo"
          class="form-control"
          [disabled]="activar || desactivarNivel"
          [(ngModel)]="buscar.nivel"
          (change)="onChangeCursos()">
          <option value="null">SELECCIONE CURSO/GRADO</option>
          <option *ngFor="let item of niveles" [value]="item.id">{{item.descripcion | uppercase}}</option>
        </select>
      </div>
    </div>
  <div class="col-sm-4">
    <div class="input-group input-group-sm mb-0">
      <select
      name="alumnoTipo"
      class="form-control"
      [(ngModel)]="buscar.especialidad"
      [disabled]="activar"
      (change)="onChangeEspecialidad()">
      <option value="null">SELECCIONE NIVEL</option>
        <option *ngFor="let item of especializaciones" [value]="item.id">{{item.descripcion | uppercase}}</option>
      </select>
    </div>
  </div>
  <div class="col-sm-4">
    <div class="input-group input-group-sm mb-0">
      <select
      name="alumnoTipo"
      class="form-control"
      [disabled]="activar"
      (change)="onChangeParalelo()"
      [(ngModel)]="buscar.paralelo">
      <option value="null">SELECCIONE PARALELO</option>
      <option *ngFor="let item of paralelos" [value]="item.id">{{item.descripcion | uppercase}}</option>
      </select>
    </div>
  </div>

</div>
  `,
  styles: [],
  providers:[LoopBackAuth, matriculaService, listadosService, validacionService,MessageService]
})
export class SelectCursoEspecialidadParaleloComponent implements OnInit {
  @Input() buscar
  @Input() activar
  @Input() tipoActivacion
  @Input() idPeriodo = null
  @Output() emittCursoCompleto= new EventEmitter()
  @Output() emittNivel= new EventEmitter()
  niveles: any
  lista: any
  especializaciones: any
  filtroNiveles: any
  paralelos: any
  desactivarNivel = false

  constructor(
    private matriculaService:matriculaService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.listaCursosAsignados()
  }

  listaCursosAsignados(){
    console.log("peridod", this.tipoActivacion,this.idPeriodo);
    this.matriculaService.listasCursos('nivel',this.tipoActivacion,this.idPeriodo).subscribe(
      lista =>{
        console.log("Niveles -->",lista)
         this.niveles = lista
      }
    )
  }

  onChangeParalelo(){
    let index = this.filtroNiveles.findIndex(item=> item.aca_curso_nivel_id == this.buscar.nivel && item.aca_curso_especialidad_id == this.buscar.especialidad && item.aca_curso_paralelo_id == this.buscar.paralelo )
    this.buscar.idCursoCompleto = this.filtroNiveles[index].aca_curso_completo_id
    sessionStorage.setItem('curso', JSON.stringify(this.buscar))
    this.emittCursoCompleto.emit(this.filtroNiveles[index])

  }

  onChangeCursos(tipo = 0){
    this.emittNivel.emit(this.buscar.nivel)
    if(tipo == 0 || this.buscar.nivel == 'null'){
      this.buscar.especialidad = null
      this.buscar.paralelo = null
      this.emittCursoCompleto.emit(0)
    }
    this.lista = null

    if(this.buscar.nivel != 'null'){

      this.matriculaService.searchCursoPorNivel(
        this.buscar.nivel,
        this.tipoActivacion,
        this.buscar.especialidad,
        this.buscar.paralelo,
        this.idPeriodo
        ).subscribe(
      lista =>{
         console.log("cursos", lista)
          if(lista != null){
            let especialidades = []
            for (let item  of lista){
              let count =0
              for(let especialidad of especialidades){
                if(item.aca_curso_especialidad_id == especialidad.id) count++
              }
              if(count == 0) especialidades.push({id: item.aca_curso_especialidad_id, descripcion: item.aca_curso_especialidad_descripcion})
            }
            this.especializaciones = especialidades
            this.filtroNiveles = lista

          }

        }
      )
    }

  }

  onChangeEspecialidad(){
    this.lista = null
    this.paralelos = this.buscarParalelos(this.buscar.especialidad)
  }

  buscarParalelos(especialidadId){
    let paralelos = []
    for (let item  of this.filtroNiveles){
       if(item.aca_curso_especialidad_id == especialidadId){
         paralelos.push({id:item.aca_curso_paralelo_id, descripcion: item.aca_curso_paralelo_descripcion})
       }
    }
    return paralelos
  }

  onSearch(){
    if(this.buscar.nivel != null){
      this.matriculaService.searchAlumnosMatriculados(this.buscar.nivel, this.buscar.especialidad, this.buscar.paralelo).subscribe(
        lista=>{
          this.lista = lista
        }
      )
    }else{
      this.toastr.warning("No ha seleccionado el nivel","Alerta")
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/element/select-curso-especialidad-paralelo.component.ts